/*
 * <pdp-gift-card> — client-side bits of the gift card recipient block.
 *
 *   - "Send on": min today, max today + 90 (Shopify's scheduling limit),
 *     defaults to today. Set here, not in Liquid, so a cached page never
 *     offers yesterday.
 *   - __shopify_offset: buyer's timezone offset, which Shopify uses to send
 *     on the right local day.
 *   - live 0/200 message counter.
 */
class PdpGiftCard extends HTMLElement {
  connectedCallback() {
    const date = this.querySelector("[data-gift-card-date]");
    if (date) {
      const today = new Date();
      const max = new Date();
      max.setDate(today.getDate() + 90);
      date.min = this._iso(today);
      date.max = this._iso(max);
      if (!date.value) date.value = date.min;
    }

    const offset = this.querySelector("[data-gift-card-offset]");
    if (offset) offset.value = new Date().getTimezoneOffset();

    this.message = this.querySelector("[data-gift-card-message]");
    this.count = this.querySelector("[data-gift-card-count]");
    if (this.message && this.count) {
      this._onInput = () => {
        this.count.textContent = `${this.message.value.length}/${this.message.maxLength}`;
      };
      this.message.addEventListener("input", this._onInput);
      this._onInput();
    }
  }

  disconnectedCallback() {
    this.message?.removeEventListener("input", this._onInput);
  }

  // Local date as YYYY-MM-DD (toISOString would shift to UTC).
  _iso(d) {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
}

customElements.define("pdp-gift-card", PdpGiftCard);
